import { format } from 'date-fns';
import TableCellStatus from '../../components/table-cell-status/table-cell-status.component';
import { displayCellValue, displayCellValueNumberToTwoDecimal } from '../../utils/column-values.util';
import { useMediaQuery } from 'react-responsive';

export const STOCK_TRANSFER_REPORT_BY_ORDER_INFO = {
  reportTitle: "Stock Reports",
  path: "/inventoryreports",
  subPath: "/stocktransfer",
  listPage: "/stock-transfer-reports",
  hasDateRange: true,
  hasChart: false,
  tableHasGrandTotal: true,
}

export const STOCK_TRANSFER_REPORT_BY_ORDER_COLUMN_TEMPLATE = [
  {
    Header: "Transfer Code",
    accessor: "transferCode",
  },
  {
    Header: "From Branch",
    accessor: "fromLocation",
    Cell: ({ value }) => {
      const isMobileView = useMediaQuery({ maxWidth: 991 });

      if (isMobileView) {
          return `From: ${displayCellValue(value)}`;
      }

      return displayCellValue(value);
  }
  },
  {
    Header: "To Branch",
    accessor: "toLocation",
    Cell: ({ value }) => {
      const isMobileView = useMediaQuery({ maxWidth: 991 });

      if (isMobileView) {
          return `To: ${displayCellValue(value)}`;
      }

      return displayCellValue(value);
  }
  },
  {
    Header: "Requested Date",
    accessor: "requestedDate",
    Cell: ({ value }) => {
      return displayCellValue(value);
    }
  },
  {
    Header: "Status",
    accessor: "stockTransferStatus",
    Cell: ({ value }) => {
      const isMobileView = useMediaQuery({ maxWidth: 991 });
      const isRightAligned = true;

      if (!value) {
        return displayCellValue(value);
      }

      return (
        <div className={isMobileView && isRightAligned ?
          'report-table__body__row__cell--right-aligned-mobile-cell' : ''}>
          <TableCellStatus
            value={value}
          />
        </div>
      )
    }
  },
]
